.container {
    margin-top: 4px;
    padding: 8px 12px;
    background: var(--mantine-color-dark-9);
    border: 1px solid var(--mantine-color-dark-3);
    border-radius: 4px;
}

@keyframes fade {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

.fade {
    animation: fade 200ms ease-in-out 0s 1 forwards normal;
}

.text {
    color: var(--mantine-color-gray-4);
    font-size: 12px;
}

.linkText {
    color: var(--mantine-color-gray-4);
    font-size: 12px;
    text-decoration: underline;
}
